import type {
  MPLPreApprovalOffer,
  OnlineGroupSectionElement,
} from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

export const isMplPreApprovalOfferElement = (element: OnlineGroupSectionElement): element is MPLPreApprovalOffer => {
  return element.type === 'preApprovalsOffer';
};
